function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clientBillListApi, clientBillStatusApi, getbillCate as _getbillCate, billCateApi, billDelFinanceApi } from '@/api/enterprise';
export default {
  name: 'Index',
  components: {
    formBox: function formBox() {
      return import('./components/formBox');
    },
    examineDialog: function examineDialog() {
      return import('@/views/fd/examine/components/examineDialog');
    },
    operationDialog: function operationDialog() {
      return import('@/views/fd/examine/components/operationDialog');
    },
    ElImageViewer: function ElImageViewer() {
      return import('element-ui/packages/image/src/image-viewer');
    },
    exportExcel: function exportExcel() {
      return import('@/components/common/exportExcel');
    },
    applyForPayment: function applyForPayment() {
      return import('@/views/customer/list/components/applyForPayment');
    },
    expendDialog: function expendDialog() {
      return import('@/views/customer/list/components/expendDialog');
    }
  },
  props: {
    activeName: {
      type: String,
      default: '1'
    },
    types: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      tableData: [],
      dialogVisible: false,
      reason: '拒绝原因',
      title: '审核未通过',
      paymentType: '',
      form: {
        remarks: ''
      },
      saveName: '',
      exportData: {
        data: [],
        cols: [{
          wpx: 130
        }, {
          wpx: 70
        }, {
          wpx: 120
        }, {
          wpx: 120
        }, {
          wpx: 130
        }, {
          wpx: 130
        }, {
          wpx: 110
        }, {
          wpx: 110
        }]
      },
      statusOptions: [],
      catePath: [],
      rules: {
        remarks: [{
          required: true,
          message: '请填写拒绝原因',
          trigger: 'blur'
        }]
      },
      where: {
        types: '',
        page: 1,
        status: 0,
        time: '',
        name: '',
        time_field: 'time',
        limit: 15,
        no_withdraw: 1,
        sort: ''
      },
      paymentId: '',
      total: 0,
      config: {},
      isImage: false,
      srcList: [],
      operationDialog: {},
      fromData: {}
    };
  },
  created: function created() {
    this.where.status = this.types;
    this.getTableData();
    this.getOption();
  },
  methods: {
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getTableData();
    },
    sortChange: function sortChange(column) {
      if (column.order === 'ascending') {
        this.where.sort = column.prop + ' asc';
      } else if (column.order === 'descending') {
        this.where.sort = column.prop + ' desc';
      } else {
        this.where.sort = '';
      }
      this.getTableData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getTableData();
    },
    tabClick: function tabClick() {
      if (this.activeName == '1') {
        this.where.status = '0';
        this.getTableData();
      } else {
        this.where.status = '';
        this.getTableData();
      }
    },
    // 查看
    handleCheck: function handleCheck(item) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (item.status === 0) {
                _this.paymentType = 'fd';
              } else {
                _this.paymentType = '';
              }
              _this.fromData = {
                title: _this.$t('customer.viewcustomer'),
                width: '500px',
                data: item,
                isClient: false,
                edit: true
              };
              _this.$refs.applyForPayment.openBox();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 撤回审核
    withdraw: function withdraw(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              data = {
                status: -1
              };
              _context2.next = 3;
              return _this2.$modalSure('确认撤回审核状态吗');
            case 3:
              _context2.next = 5;
              return clientBillStatusApi(row.id, data);
            case 5:
              _this2.getTableData();
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 拒绝
    refuse: function refuse(row) {
      this.dialogVisible = true;
      this.paymentId = row.id;
    },
    // 导出
    getExportData: function getExportData() {
      var _this3 = this;
      this.saveName = '导出付款审核_' + this.$moment(new Date()).format('MM_DD_HH_mm_ss') + '.xlsx';
      this.where.limit = 0;
      var where = {
        types: this.where.types,
        page: this.where.page,
        status: this.where.status,
        time: this.where.time,
        name: this.where.name,
        time_field: this.where.time_field,
        limit: 0,
        no_withdraw: this.where.no_withdraw
      };
      clientBillListApi(where).then(function (res) {
        var data = res.data.list;
        var aoaData = [['付款时间', '付款金额', '支付方式', '备注', '业务类型', '客户名称', '合同名称', '合同编号', '业务员']];
        if (data.length > 0) {
          data.forEach(function (value) {
            if (value.types == 0) {
              value.types = '回款记录';
            } else {
              if (value.renew) {
                value.types = '续费记录' + '-' + value.renew;
              } else {
                value.types = '续费记录';
              }
            }
            aoaData.push([value.date, value.num, value.pay_type, value.mark, value.types, value.client ? value.client.name : '', value.treaty ? value.treaty.title : '', value.treaty ? value.treaty.contract_no : '', value.card ? value.card.name : '']);
          });
          _this3.exportData.data = aoaData;
          _this3.$refs.exportExcel.exportExcel();
        }
      });
      this.where.page = 1;
      this.where.limit = 10;
      this.getTableData();
    },
    submitFn: function submitFn() {
      var _this4 = this;
      var data = {
        fail_msg: this.form.remarks,
        status: 2
      };
      this.$refs.from.validate(function (valid) {
        if (valid) {
          clientBillStatusApi(_this4.paymentId, data).then(function (res) {
            _this4.getTableData();
            _this4.dialogVisible = false;
            _this4.form.remarks = '';
          });
        }
      });
    },
    getbillCate: function getbillCate(id) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _getbillCate(id).then(function (res) {
                _this5.catePath = res.data.bill_cate_path;
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getOption: function getOption() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              billCateApi().then(function (res) {
                _this6.statusOptions = res.data;
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 通过
    handleContract: function handleContract(row, type) {
      var _this7 = this;
      this.catePath = [];
      this.getbillCate(row.cid);
      var str = '审核通过';
      if (type === 'edit') {
        str = '编辑账目记录';
      }
      setTimeout(function () {
        _this7.operationDialog = {
          title: str,
          data: row,
          path: _this7.catePath,
          type: type,
          source: 'fd'
        };
      }, 200);
      if (row.types !== 2) {
        this.$refs.operationDialog.handleOpen();
      } else {
        this.$refs.expendDialog.handleOpen();
      }
    },
    cancelFn: function cancelFn() {
      this.dialogVisible = false;
      this.form.remarks = '';
    },
    handlePictureCardPreview: function handlePictureCardPreview(val) {
      this.srcList.push(val);
      this.isImage = true;
    },
    closeImageViewer: function closeImageViewer() {
      this.isImage = false;
      this.srcList = [];
    },
    getStatus: function getStatus(id) {
      var str = '';
      if (id === 0) {
        str = this.$t('customer.audit');
      } else if (id === 1) {
        str = this.$t('customer.passed');
      } else {
        str = this.$t('customer.fail');
      }
      return str;
    },
    // 获取表格数据
    getTableData: function getTableData() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var result;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return clientBillListApi(_this8.where);
            case 2:
              result = _context5.sent;
              _this8.tableData = result.data.list;
              _this8.total = result.data.count;
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    // 删除
    handleDelete: function handleDelete(item) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this9.$modalSure(_this9.$t('finance.message5'));
            case 2:
              _context6.next = 4;
              return billDelFinanceApi(item.id);
            case 4:
              _this9.getTableData();
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    // 编辑
    handleEdit: function handleEdit(item) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this10.config = {
                title: _this10.$t('customer.fundaudit'),
                width: '480px',
                type: 1,
                data: item
              };
              _this10.$refs.examineDialog.handleOpen();
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    confirmData: function confirmData(data) {
      this.where.status = this.activeName == 1 ? 0 : data.status;
      this.where.types = data.type;
      this.where.date = data.date;
      this.where.field_key = data.select;
      this.where.name = data.name;
      this.where.time_field = data.time_field;
      this.where.time = data.time;
      this.where.page = 1;
      this.getTableData();
    },
    isOk: function isOk() {
      this.getTableData();
    }
  }
};